<template>
	<section class="wrapper">
		<router-view />
	</section>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore'
import { CustomNavTabs, EmptyNavSection } from '@/customNavSection'


export default {
	inject: ['headerHeight', 'customNavSection'],

	components: {
	},

	props: {
		session: {
			type: Object,
			required: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()

		return {
			accountStore,
		}
	},

	data() {
		return {
			// Tabs for page sections
			tabs: new CustomNavTabs(),
		}
	},

	created() {},

	mounted() {
		this.showSections()
	},

	methods: {
		showSections() {
			// Create custom navigation data model
			let events_table = false,
				alerts_table = false,
				stationSubscriptions=false,
				postSubscriptions=false

			// Add tabs
			this.tabs.addLine('events_table', 'Журнал подій', null, events_table)
			this.tabs.addLine('alerts_table', 'Всі СКЗ', null, alerts_table)
			this.tabs.addLine('station_subscriptions', 'Підписки СКЗ', null, stationSubscriptions)
			this.tabs.addLine('post_subscriptions', 'Підписки КВП', null, postSubscriptions)

			// Publicate new custom navigation section for nav component
			this.customNavSection = this.tabs

			// Marck active tab on page load
			this.tabs.checkTab(this.$route.name)
		}
	},

	computed: {},

	beforeUnmount() {
		// Clear custom nav section
		this.customNavSection = new EmptyNavSection()
	},

	unmounted() {},
}
</script>



<style scoped>
.wrapper {
	position: relative;
	
	width: 100%;
	height: calc(100vh - v-bind(headerHeight));

	overflow-x: hidden;
	overflow-y: hidden;
}
</style>
